const CategoryNavLinkBuilderComponent = {
  name: '_CategoryNavLink_',
  canHaveChildren: true,
  childRequirements: {
    message: 'Child component for a CategoryNavLink must be a CategoryNavLink.',
    query: {
      'component.name': {
        $in: ['_CategoryNavLink_'],
      },
    },
  },
  inputs: [
    {
      name: 'linkText',
      friendlyName: 'Category Nav Link Text.',
      helperText:
        'Default category text displayed. Use the "Category Nav Link Text Override" field in Advanced options to customize.',
      type: 'string',
      defaultValue: 'Womens',
      localized: true,
      required: true,
    },
    {
      name: 'linkPath',
      friendlyName: 'Category Nav Link Path',
      helperText: 'Only include the URL path. Ex- /womens',
      type: 'string',
      defaultValue: '/womens',
      localized: true,
      required: true,
    },
    {
      name: 'linkTextOverride',
      friendlyName: 'Category Nav Link Text Override',
      helperText:
        'Overrides the default category text input and is intended to display T2 links differently than T3 links primarily for the Category Tabs. E.g. Instead of "Womens" it would say "All Womens".',
      type: 'string',
      localized: true,
      required: false,
      advanced: true,
    },
  ],
} as const;

export default CategoryNavLinkBuilderComponent;
